import { useState } from "react";
import {
    CompanyDepartmentFormState_default,
    CompanyDepartmentFormState_toRequest
} from "../../types/forms/CompanyDepartmentFormState";
import { createCompanyDepartmentAsync } from "../../apiClient";
import { CreateCompanyDepartmentModalProps } from "./CreateCompanyDepartmentModal";
import { showDangerAlert } from "../../common";

function useCreateCompanyDepartmentModal(props: CreateCompanyDepartmentModalProps) {
    const [companyDepartmentFormState, setCompanyDepartmentFormState] = useState(CompanyDepartmentFormState_default());
    const [requestInProgress, setRequestInProgress] = useState(false);

    const disableSubmit = !companyDepartmentFormState.name.value.trim() || requestInProgress;

    function handleNameChange(name: string) {
        setCompanyDepartmentFormState((prevState) => ({
            ...prevState,
            name: { value: name, errorMessage: undefined }
        }));
    }

    async function handleSubmitAsync(e: React.FormEvent) {
        e.preventDefault();

        const request = CompanyDepartmentFormState_toRequest(companyDepartmentFormState);

        setRequestInProgress(true);
        const result = await createCompanyDepartmentAsync(props.companyId, request);
        setRequestInProgress(false);

        if (result.failed) {
            console.error("Failed to create company department. Request:", request, "Error:", result.error);
            const nameErrors = result.error.errors["Name"];
            const nameErrorMessage = nameErrors && nameErrors.length > 0 ? nameErrors[0] : undefined;

            if (!nameErrorMessage) {
                showDangerAlert(props.resources.get("CreateCompanyDepartmentError") ?? "");
                return;
            }

            setCompanyDepartmentFormState((prevState) => ({
                ...prevState,
                name: {
                    ...prevState.name,
                    errorMessage: nameErrorMessage
                }
            }));

            return;
        }

        props.onDepartmentCreated();
    }

    function handleIsEnergyHarbourCustomerChange(isChecked: boolean) {
        setCompanyDepartmentFormState((prevState) => ({
            ...prevState,
            isEnergyHarbourCustomer: { value: isChecked, errorMessage: undefined }
        }));
    }

    return {
        companyDepartmentFormState,
        disableSubmit,
        setCompanyDepartmentFormState,
        handleNameChange,
        handleIsEnergyHarbourCustomerChange,
        handleSubmitAsync
    };
}

export default useCreateCompanyDepartmentModal;
